/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import {
  faCalculator,
  faChevronDown,
  faChevronUp,
  faClock,
  faExclamationTriangle,
  faSearch,
  faUser,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjcSelector from "@grapecity/wijmo.grid.selector"
import dayjs from "dayjs"
import queryString from "query-string"
import { useEffect, useRef, useState } from "react"
import { generatePath } from "react-router"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  OverlayTrigger,
  Row,
  Table,
  Tooltip,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import MonthInput from "../../../components/InputWrapper/MonthInput"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { メニューコード } from "../../../constant/menuCode"
import {
  clearAlert,
  setAlerts,
  setInfoAlerts,
} from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import { RootState } from "../../../globalStore/rootreducer"
import ZyomuinUnkoGeppoService from "../../../service/driverpayroll/zyomuinUnkoGeppo/zyomuinUnkoGeppoService"
import {
  TZyomuinUnkoGeppoSummaryListGetReq,
  TZyomuinUnkoGeppoPrintReq,
  TZyomuinUnkogeppoCreateReq,
  TZyomuinUnkoGeppoSummaryGetRes,
} from "../../../service/driverpayroll/zyomuinUnkoGeppo/TZyomuinUnkoGeppo"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import util from "../../../ts/util"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"
import { faFileAlt } from "@fortawesome/free-regular-svg-icons"
import BusyoService from "../../../service/master/busyo/busyoService"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import kengenUtil from "../../../ts/util/kengenUtil"

/**
 * 乗務員運行月報 一覧
 * @returns
 */
const ZyomuinUnkoGeppoList = () => {
  const history = useHistory()
  const location = useLocation()
  const eigyobi = useSelector((state: RootState) => state.date.eigyobiStr)

  // ref
  const ref年月 = useRef<string>(eigyobi)

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "ZyomuinUnkoGeppoList_GridId"

  // 権限制御
  const userInfo = useSelector(
    (rootState: RootState) => rootState.user.LoginUserInfo
  )

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TZyomuinUnkoGeppoSummaryGetRes>,
    pageSize: number
  ) => {
    return new wjCore.CollectionView(data, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
      calculatedFields: {
        貼付用社員番号: (data: TZyomuinUnkoGeppoSummaryGetRes) =>
          data.社員コード,
        貼付用社員名: (data: TZyomuinUnkoGeppoSummaryGetRes) => data.社員氏名,
        padding社員コード: (data: TZyomuinUnkoGeppoSummaryGetRes) =>
          data.社員コード != null && data.社員コード !== ""
            ? data.社員コード?.padStart(4, "0")
            : "9999",
      },
    })
  }

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (
    searchCondition?: TZyomuinUnkoGeppoSummaryListGetReq
  ) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TZyomuinUnkoGeppoSummaryListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    if (currentSearchCondition == null) return
    setPreSearchCondition({ ...currentSearchCondition })

    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new ZyomuinUnkoGeppoService().getSummaryList(
        currentSearchCondition
      )
      dispatch(setAlerts(res))

      // formatItem入れ直し
      flexGrid?.formatItem.removeHandler(formatItem)
      flexGrid?.formatItem.addHandler(formatItem)

      // その他情報をstateに設定
      set乗務員運行月報Id(res.data.乗務員運行月報ID)
      set月報作成日時(res.data.月報作成日時)
      set月報作成者(
        `${res.data.月報作成者?.社員コード} : ${res.data.月報作成者?.社員氏名}`
      )

      // 検索結果をstateに設定
      setGridData({
        data: createCollectionView(res.data.乗務員運行月報集計List, pageSize),
      })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TZyomuinUnkoGeppoSummaryListGetReq = queryString.parse(
      location.search
    )
    set年月(query.年月)
    set部所コード(query.部所コード)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TZyomuinUnkoGeppoSummaryListGetReq => {
    return {
      年月: 年月 ?? new Date().toISOString(),
      部所コード: 部所コード ?? "",
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TZyomuinUnkoGeppoSummaryListGetReq
  ) => {
    const disp年月 = dayjs(searchCondition.年月).format("YYYY/MM")

    const disp部所 = 部所ItemSource?.find(
      (i) => i.部所コード === searchCondition.部所コード
    )
    return {
      年月: wjCore.isNullOrWhiteSpace(disp年月 ?? "") ? "" : disp年月,
      部所コード: disp部所
        ? `${disp部所.部所コード} ${disp部所.部所略称}`
        : undefined,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
    // AlertClear
    dispatch(clearAlert())
  }

  const clearSearchState = () => {
    set年月(eigyobi)
    ref年月.current = eigyobi

    set部所コード("")
    set部所(undefined)
    set部所ItemSource(undefined)
  }

  /**
   * 乗務員運行月報 帳票作成指示 処理
   */
  const printZyomuinUnkoGeppo = async () => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    // 印刷条件の設定
    let 対象社員ID: number[] = []

    selectedRows?.forEach((row) => {
      対象社員ID.push(row.dataItem.社員ID)
    })

    const printCondition: TZyomuinUnkoGeppoPrintReq = {
      抽出条件_乗務員運行月報ID: 乗務員運行月報Id!,
      抽出条件_社員ID: 対象社員ID,
    }

    try {
      const res = await new ZyomuinUnkoGeppoService({
        responseType: "blob",
      }).printZyomuinUnkoGeppo(printCondition)

      var fileURL = URL.createObjectURL(res)
      window.open(fileURL)
      setTimeout(() => {
        URL.revokeObjectURL(fileURL)
      }, 500)
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * 乗務員運行月報 集計実行指示 処理前
   */
  const beforeCalcZyomuinUnkoGeppo = async () => {
    clearError()
    setIsConfirmModalShow(true)
  }

  /**
   * 乗務員運行月報 集計実行指示 処理
   */
  const calcZyomuinUnkoGeppo = async () => {
    const condition: TZyomuinUnkogeppoCreateReq = {
      年月: dayjs(preSearchCondition.年月).toISOString(),
    }

    try {
      await new ZyomuinUnkoGeppoService().calcZyomuinUnkoGeppo(condition)
      dispatch(
        setInfoAlerts([
          "乗務員運行月報の集計を開始しました。しばらくしたら再度検索してください。",
        ])
      )

      // データをすべて削除する
      const emptyCollectionView = createCollectionView([], pageSize)
      flexGrid!.itemsSource = emptyCollectionView
      setGridData({ data: emptyCollectionView })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    // ヘッダーに行追加
    // header行に一行追加
    // 追加行のみ初期化時に設定
    var extraRow = new wjcGrid.Row()
    extraRow.allowMerging = true
    var columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    // ヘッダグループのラベルを定義
    columnHeaders.columns.forEach((c, index) => {
      switch (c.binding) {
        case "部所略称":
        case "社員コード":
        case "社員氏名":
          columnHeaders.setCellData(0, index, "乗務員")
          break
        case "勤務数":
        case "休出数":
        case "祝出数":
          columnHeaders.setCellData(0, index, "勤怠日数")
          c.format = "F2"
          break
        case "有休数":
        case "特休数":
        case "運行外業務数":
          columnHeaders.setCellData(0, index, "勤怠日数")
          c.format = "F"
          break
        case "乗務員売上":
        case "乗務員付帯料":
        case "付帯高速料":
        case "乗務員売上計":
          columnHeaders.setCellData(0, index, "乗務員売上明細")
          break
        case "ETC高速料":
          columnHeaders.setCellData(0, index, "ETC")
          break
        case "運転回数":
          columnHeaders.setCellData(0, index, "運転回数")
          break
        case "同乗回数":
          columnHeaders.setCellData(0, index, "同乗回数")
          break
        case "長距離回数":
          columnHeaders.setCellData(0, index, "長距回数")
          break
        case "休白丸数":
          columnHeaders.setCellData(0, index, "休○")
          break
        case "走行距離":
          columnHeaders.setCellData(0, index, "走行距離")
          break
        case "食事手当":
        case "稼働手当":
        case "特別手当":
        case "その他手当":
          columnHeaders.setCellData(0, index, "手当")
          break
        case "貼付用社員番号":
        case "貼付用社員名":
        case "稼働調整":
          columnHeaders.setCellData(0, index, "貼付用")
          break
      }
      c.align = "center"
      c.allowMerging = true
    })

    // ヘッダの設定
    grid.formatItem.addHandler(formatItem)

    // 行頭選択
    new wjcSelector.Selector(grid, {
      itemChecked: () => {
        setSelectedRows([...grid.rows.filter((r) => r.isSelected)])
      },
    })

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      const cellBinding = e.getColumn().binding
      let col = f.columns[e.col]
      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        const dataItem: TZyomuinUnkoGeppoSummaryGetRes = e.getRow().dataItem

        switch (col.binding as keyof TZyomuinUnkoGeppoSummaryGetRes) {
          case "ETC高速料":
            if (dataItem.受注配車工程不明フラグ === 1) {
              wjCore.toggleClass(e.cell, "warn", true)
            }
            break
          default:
            break
        }
      }
    }
  }

  /**
   * エラークリア
   */
  const clearError = () => {
    dispatch(clearAlert())
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  const [年月, set年月] = useState<string | null>()
  const [月報作成日時, set月報作成日時] = useState<string | null>()
  const [月報作成者, set月報作成者] = useState<string | null>()
  const [乗務員運行月報Id, set乗務員運行月報Id] = useState<number | null>()
  const [部所コード, set部所コード] = useState<string | null>()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  // 行選択
  const [selectedRows, setSelectedRows] = useState<wjcGrid.Row[]>()

  //#endregion

  //#region [state]

  const [, set部所] = useState<T部所マスタ | null>()
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()

  //#endregion

  //#region comboboxState
  // 部所
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    T部所マスタ["部所コード"],
    T部所マスタ
  > | null>(null)
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false)

  const [isComboboxItemInitialized, setIsComboboxItemInitialised] =
    useState(false)
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  const [preSearchCondition, setPreSearchCondition] =
    useState<TZyomuinUnkoGeppoSummaryListGetReq>(
      {} as TZyomuinUnkoGeppoSummaryListGetReq
    )

  //#endregion

  //#region [effect]

  useEffect(() => {
    document.title = `乗務員 運行月報一覧`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])

  useEffect(() => {
    Promise.all([new BusyoService().getList({})]).then(([部所ListRes]) => {
      set部所ItemSource(部所ListRes.data)
      setIsComboboxItemInitialised(true)
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && 部所ComboBox && isComboboxItemInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized, 部所ComboBox, isComboboxItemInitialized])

  //#endregion

  //#region [components]

  const GeppoResults = () => (
    <>
      <div className={"d-inline-block, ms-3 align-middle"}>
        <FontAwesomeIcon
          className={"align-middle ms-1 me-2 text-secondary"}
          icon={faClock}
        />
        <span className={"align-middle ms-1"}>月報作成日時:</span>
        <span className={"align-middle ms-1"}>
          {月報作成日時
            ? dayjs(月報作成日時).format("YYYY/MM/DD HH:mm:ss")
            : ""}
        </span>
      </div>
      <div className={"d-inline-block ms-3 align-middle"}>
        <FontAwesomeIcon
          className={"align-middle ms-1 me-2 text-secondary"}
          icon={faUser}
        />
        <span className={"align-middle ms-1"}>月報作成者:</span>
        <span className={"align-middle ms-1"}>{月報作成者}</span>
      </div>
    </>
  )

  //#endregion

  return (
    <>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">乗務員 運行月報 一覧</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索条件カード */}
            <Card className="w-60rem">
              {/* CardHeaderをアコーディオン化 */}
              <Card.Header
                onClick={() => setAccordionController(!accordionController)}
                aria-controls="collapse-search-card-body"
                aria-expanded={accordionController}>
                <FontAwesomeIcon
                  icon={accordionController ? faChevronDown : faChevronUp}
                  size={"1x"}
                />
                検索条件
              </Card.Header>
              <Collapse in={accordionController}>
                <Card.Body>
                  <Form>
                    <Container fluid className="contents-search-main">
                      <Row>
                        <Col>
                          <Table className="search-table">
                            <tbody>
                              <tr>
                                <td>
                                  <div className="w-8rem">
                                    <MonthInput
                                      id="年月"
                                      value={年月}
                                      setValue={set年月}
                                      defaultValue={eigyobi}
                                      isRequired
                                      placeholder="年月"
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div className="w-20rem">
                                    <ComboBox.Busyo
                                      placeholder="部所"
                                      isAllSelect={true}
                                      itemsSource={部所ItemSource}
                                      isLoadEnded={部所IsLoadEnded}
                                      setIsLoadEnded={set部所IsLoadEnded}
                                      setSelectedValue={set部所コード}
                                      selectedValue={部所コード}
                                      setSelectedItem={set部所}
                                      listFilter={(d) => d.運行部所フラグ === 1}
                                      ComboBox={部所ComboBox}
                                      setComboBox={
                                        set部所ComboBox
                                      }></ComboBox.Busyo>
                                  </div>
                                </td>
                                <td>
                                  <Button
                                    type="submit"
                                    disabled={isSearching}
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      e.preventDefault()
                                      search()
                                    }}>
                                    <FontAwesomeIcon icon={faSearch} />
                                    検索
                                  </Button>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </Col>
                      </Row>
                      <Row>
                        <Col className="text-end"></Col>
                      </Row>
                    </Container>
                  </Form>
                </Card.Body>
              </Collapse>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索結果カード */}
            <Card>
              <Spinner searching={isSearching}></Spinner>
              <Card.Body>
                <Row>
                  <Col>
                    {/* 検索条件表示コンポーネント */}
                    <DisplaySearchConditionLabel
                      displaySearchCondition={displaySearchCondition}
                    />
                  </Col>
                </Row>
                <FlexGridOuter
                  flexGrid={flexGrid}
                  setFlexGrid={setFlexGrid}
                  gridConstantProperties={
                    CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS
                  }
                  gridData={gridData}
                  setGridData={setGridData}
                  style={{ maxHeight: "auto", height: "calc(100vh - 31.3rem)" }}
                  pageNumber={pageNumber}
                  searchConditionClear={searchConditionClear}
                  gridId={gridId}
                  isRestoreSearching={isRestoreSearching}
                  setIsRestoreSearching={setIsRestoreSearching}
                  gridInitialized={gridInitialized}
                  setGridInitialized={setGridInitialized}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  gridInitializedHandler={gridInitializedHandler}
                  isShowGridRowPickupButton={true}
                  hasFilter={false}
                  gridProperties={{
                    frozenColumns: 4,
                    allowSorting: wjcGrid.AllowSorting.None,
                    allowDragging: wjcGrid.AllowDragging.None,
                  }}
                  headerComponent={
                    <div className="d-flex">
                      <Button
                        variant="done"
                        disabled={
                          isSearching ||
                          selectedRows == null ||
                          selectedRows.length <= 0
                        }
                        onClick={(e) => {
                          e.preventDefault()
                          e.stopPropagation()
                          printZyomuinUnkoGeppo()
                        }}>
                        <FontAwesomeIcon icon={faFileAlt} />
                        選択乗務員運行月報　印刷
                      </Button>
                      <Button
                        variant="waiting"
                        className={"ms-5"}
                        disabled={isSearching}
                        hidden={
                          !kengenUtil.乗務員運行月報の集計実行ボタンの使用権限判定(
                            userInfo
                          )
                        }
                        onClick={(e) => {
                          e.preventDefault()
                          e.stopPropagation()
                          beforeCalcZyomuinUnkoGeppo()
                        }}>
                        <FontAwesomeIcon icon={faCalculator} />
                        乗務員運行月報　集計実行
                      </Button>
                      {月報作成日時 ? <GeppoResults /> : null}
                    </div>
                  }>
                  {/* ここから固定列 Start */}
                  <wjrGrid.FlexGridColumn
                    cssClass="text-center"
                    width={30}
                    header=""></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="部所略称"
                    cssClass="text-start"
                    width={80}
                    header="部所"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="社員コード"
                    cssClass="text-start"
                    width={70}
                    header="社員番号"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="社員氏名"
                    cssClass="text-start"
                    width={100}
                    header="氏名">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TZyomuinUnkoGeppoSummaryGetRes>
                      ) => {
                        return (
                          <a
                            className="text-center text-primary"
                            rel="noreferrer"
                            href={generatePath(
                              util.getMenuPath(
                                メニューコード.給与管理.乗務員運行月報
                              )[0],
                              {
                                geppoid: context.item.乗務員運行月報ID,
                                syainid: context.item.社員ID,
                              }
                            )}>
                            {context.item.社員氏名}
                          </a>
                        )
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  {/* ここまで固定列 End */}
                  {/* 以下スクロール列 */}
                  <wjrGrid.FlexGridColumn
                    binding="勤務数"
                    cssClass="text-end"
                    width={60}
                    header="出勤"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="休出数"
                    cssClass="text-end"
                    width={60}
                    header="休出"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="祝出数"
                    cssClass="text-end"
                    width={60}
                    header="祝出"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="特休数"
                    cssClass="text-end"
                    width={40}
                    header="特休"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="有休数"
                    cssClass="text-end"
                    width={40}
                    header="有休"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="運行外業務数"
                    cssClass="text-end"
                    width={60}
                    header="運外"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="休白丸数"
                    cssClass="text-end"
                    format="n0"
                    dataType="Number"
                    width={40}
                    header="休○"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="走行距離"
                    cssClass="text-end"
                    format="n0"
                    dataType="Number"
                    width={80}
                    header="走行距離"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="ETC高速料"
                    cssClass="text-end"
                    format="n0"
                    width={90}
                    header="ETC">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TZyomuinUnkoGeppoSummaryGetRes>
                      ) => {
                        // 休日カレンダー判定
                        if (context.item.受注配車工程不明フラグ === 1) {
                          return (
                            <OverlayTrigger
                              placement={"right"}
                              overlay={
                                <Tooltip className="tooltip-warn">
                                  受注配車工程が不明なETCデータが存在します。
                                </Tooltip>
                              }>
                              <div className={`d-table`}>
                                <FontAwesomeIcon
                                  icon={faExclamationTriangle}
                                  className={`d-table-cell align-left pt-1 warn-text`}
                                />
                                <span
                                  className={`d-table-cell align-right w-100`}>
                                  {Intl.NumberFormat().format(
                                    context.item.ETC高速料
                                  )}
                                </span>
                              </div>
                            </OverlayTrigger>
                          )
                        } else {
                          return (
                            <span>
                              {Intl.NumberFormat().format(
                                context.item.ETC高速料
                              )}
                            </span>
                          )
                        }
                      }}
                    />
                  </wjrGrid.FlexGridColumn>

                  <wjrGrid.FlexGridColumn
                    binding="乗務員売上額"
                    cssClass="text-end"
                    width={100}
                    header="乗務員売上"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="乗務員付帯料"
                    cssClass="text-end"
                    width={90}
                    header="付帯料"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="付帯高速料"
                    cssClass="text-end"
                    width={90}
                    header="付帯高速料"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="乗務員売上計"
                    cssClass="text-end"
                    width={100}
                    header="乗務員売上計"></wjrGrid.FlexGridColumn>

                  <wjrGrid.FlexGridColumn
                    binding="同乗回数"
                    width={40}
                    header="同乗回数"
                    wordWrap={true}></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="長距離回数"
                    width={40}
                    header="長距回数"
                    wordWrap={true}></wjrGrid.FlexGridColumn>

                  <wjrGrid.FlexGridColumn
                    binding="食事手当"
                    cssClass="text-end"
                    width={100}
                    header="食事手当"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="稼働手当"
                    cssClass="text-end"
                    width={100}
                    header="稼働手当"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="特別手当"
                    cssClass="text-end"
                    width={100}
                    header="特別手当"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="その他手当"
                    cssClass="text-end"
                    width={100}
                    header="その他手当"></wjrGrid.FlexGridColumn>

                  <wjrGrid.FlexGridColumn
                    binding="貼付用社員番号"
                    cssClass="text-start"
                    width={100}
                    header="社員番号"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="貼付用社員名"
                    cssClass="text-start"
                    width={100}
                    header="氏名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="稼働調整"
                    cssClass="text-end"
                    format="n0"
                    dataType="Number"
                    width={100}
                    header="稼働調整"></wjrGrid.FlexGridColumn>
                </FlexGridOuter>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={calcZyomuinUnkoGeppo}>
        乗務員運行月報の集計を実行します。
        <b>
          {dayjs(preSearchCondition.年月).format("YYYY年MM月")}
          の情報が再作成
        </b>
        されます。
        <br />
        また、この処理にはしばらく時間がかかります。
        <br />
        実行してもよろしいですか。
      </ConfirmModal>
    </>
  )
}

export default ZyomuinUnkoGeppoList
